export const pluginId = 'Confluent';
